import _typeof from "D:/wenge-Obj/zhichuan/llm-agent-web/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
export var padStart = function padStart(val) {
  if (!val) {
    return "00";
  }
  return val.toString().padStart(2, "0");
};
/**
 * 格式化日期时间
 */
export var formatDate = function formatDate(val) {
  if (!val) {
    return "";
  }
  var date = new Date(val);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  var d = date.getDate();
  var h = date.getHours();
  var mm = date.getMinutes();
  var s = date.getSeconds();
  var str = {
    date: [y, m, d].map(function (item) {
      return padStart(item);
    }).join("-"),
    timer: [h, mm, s].map(function (item) {
      return padStart(item);
    }).join(":")
  };
  return str;
};

// 计算星期几
// 计算指定时间是星期几
export var getweekday = function getweekday(date) {
  // date例如:'2022-03-05'
  var weekArray = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
  var week = weekArray[new Date(date).getDay()];
  return week;
};
/**
 * 对象数组的深度拷贝.
 * source是原数据，extendObj是新增的键值对
 */
var _objArrDeepCopy = function objArrDeepCopy(source, extendObj) {
  var sourceCopy = source instanceof Array ? [] : {};
  for (var item in source) {
    sourceCopy[item] = _typeof(source[item]) === 'object' ? _objArrDeepCopy(source[item], extendObj) : source[item];
    if (_typeof(extendObj) === 'object' && !(sourceCopy instanceof Array)) {
      for (var param in extendObj) {
        sourceCopy[param] = extendObj[param];
      }
    }
  }
  return sourceCopy;
};

/**
 * 解密
 * 加解密公钥：zhichuan-ai-public
 */
export { _objArrDeepCopy as objArrDeepCopy };
export var decryptData = function decryptData(encryptedData) {
  var decrypted = CryptoJS.AES.decrypt(encryptedData, 'zhichuan-ai-public').toString(CryptoJS.enc.Utf8);
  return decrypted;
};

/**
 * 文件大小换算
 * 1024b =1kb 1024kb=1mb
 */
export var formatFileSize = function formatFileSize(bytes) {
  if (bytes < 1024) {
    return "".concat(bytes, " B");
  } else if (bytes < 1024 * 1024) {
    var kB = bytes / 1024;
    return "".concat(kB.toFixed(1), " KB");
  } else {
    var MB = bytes / (1024 * 1024);
    return "".concat(MB.toFixed(1), " MB");
  }
};
// 字符串json转换成object
export var processParam = function processParam(param) {
  // 判断是否为对象（包括数组、日期等，但不包括 null）
  if (_typeof(param) === 'object' && param !== null) {
    return param;
  }

  // 处理字符串情况
  if (typeof param === 'string') {
    // 检查字符串是否为空或仅包含空白字符
    if (param.trim() === '') {
      return param; // 返回原空字符串
    }
    try {
      return JSON.parse(param);
    } catch (e) {
      // 解析失败，返回原字符串
      return param;
    }
  }

  // 其他类型直接返回
  return param;
};

//深拷贝
export function deepCopy(obj) {
  if (obj === null || _typeof(obj) !== 'object') {
    return obj;
  }
  var copy = Array.isArray(obj) ? [] : {};
  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key]);
  });
  return copy;
}